import React, {
  createContext,
  useState,
  useEffect,
  Context,
} from 'react';
import _ from 'lodash';
import { THEMES } from '../constants';
import { storeSettings } from '../utils/settings';
import { ContextSettings } from '../types';

const defaultSettings: ContextSettings = {
  direction: 'ltr',
  responsiveFontSizes: true,
  theme: THEMES.LIGHT,
  lang: 'en',
};

const SettingsContext: Context<ContextSettings> = createContext(defaultSettings);

export function SettingsProvider({ settings, children }: {
  settings: ContextSettings, children: React.ReactNode
}) {
  const [currentSettings, setCurrentSettings] = useState(settings || defaultSettings);

  const handleSaveSettings = (updatedSettings = {}) => {
    const mergedSettings = _.merge({}, currentSettings, updatedSettings);

    setCurrentSettings(mergedSettings);
    storeSettings(mergedSettings);
  };

  useEffect(() => {
    document.dir = currentSettings.direction || 'ltr';
  }, [currentSettings]);

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        saveSettings: handleSaveSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export const SettingsConsumer = SettingsContext.Consumer;
export default SettingsContext;
